// Split from theme.js: core globals (lines 1-1075)
/*
@license
  Concept by RoarTheme (https://roartheme.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://roartheme.co/blogs/concept/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {}
window.Shopify = window.Shopify || {}

theme.config = {
  hasSessionStorage: true,
  hasLocalStorage: true,
  mqlSmall: false,
  mediaQuerySmall: 'screen and (max-width: 767px)',
  motionReduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  isTouch: 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,
  rtl: document.documentElement.getAttribute('dir') === 'rtl' ? true : false
}

theme.supportsPassive = false

try {
  const opts = Object.defineProperty({}, 'passive', {
    get: function () {
      theme.supportsPassive = true
    }
  })
  window.addEventListener('testPassive', null, opts)
  window.removeEventListener('testPassive', null, opts)
} catch (e) {}

document.documentElement.classList.add(theme.config.isTouch ? 'touch' : 'no-touch')
;(function () {
  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  theme.DOMready = function (callback) {
    if (document.readyState != 'loading') callback()
    else document.addEventListener('DOMContentLoaded', callback)
  }

  theme.headerGroup = {
    rounded: () => {
      return Array.from(document.querySelectorAll('.shopify-section-group-header-group .section--rounded'))
    },
    sections: () => {
      return Array.from(document.querySelectorAll('.shopify-section-group-header-group'))
    },
    init: () => {
      let previousSection = null
      const rounded = theme.headerGroup.rounded()
      const sections = theme.headerGroup.sections()

      sections.forEach((shopifySection, index) => {
        const section = shopifySection.querySelector('.section')
        if (section) {
          section.classList.remove('section--next-rounded')
          section.classList.remove('section--first-rounded')
          section.classList.remove('section--last-rounded')

          if (section.classList.contains('section--rounded')) {
            if (index === 0) {
              section.classList.add('section--first-rounded')
            }

            if (index === rounded.length - 1) {
              section.classList.add('section--last-rounded')
            }

            if (previousSection && previousSection.classList.contains('section--rounded')) {
              previousSection.classList.add('section--next-rounded')
            }
          }

          if (index === sections.length - 1) {
            const nextSection = document.querySelector('.main-content .shopify-section:first-child .section')
            if (nextSection && nextSection.classList.contains('section--rounded')) {
              section.classList.add('section--next-rounded')
            }
          }

          previousSection = section
        }
      })
    }
  }

  theme.a11y = {
    trapFocusHandlers: {},

    getFocusableElements: (container) => {
      return Array.from(
        container.querySelectorAll(
          'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'
        )
      )
    },

    trapFocus: (container, elementToFocus = container) => {
      const elements = theme.a11y.getFocusableElements(container)
      const first = elements[0]
      const last = elements[elements.length - 1]

      theme.a11y.removeTrapFocus()

      theme.a11y.trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return

        document.addEventListener('keydown', theme.a11y.trapFocusHandlers.keydown)
      }

      theme.a11y.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', theme.a11y.trapFocusHandlers.keydown)
      }

      theme.a11y.trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
          event.preventDefault()
          first.focus()
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault()
          last.focus()
        }
      }

      document.addEventListener('focusout', theme.a11y.trapFocusHandlers.focusout)
      document.addEventListener('focusin', theme.a11y.trapFocusHandlers.focusin)

      elementToFocus.focus()

      if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length)
      }
    },

    removeTrapFocus: (elementToFocus = null) => {
      document.removeEventListener('focusin', theme.a11y.trapFocusHandlers.focusin)
      document.removeEventListener('focusout', theme.a11y.trapFocusHandlers.focusout)
      document.removeEventListener('keydown', theme.a11y.trapFocusHandlers.keydown)

      if (elementToFocus && typeof elementToFocus.focus === 'function') elementToFocus.focus()
    }
  }

  theme.utils = {
    throttle: (callback) => {
      let requestId = null,
        lastArgs
      const later = (context) => () => {
        requestId = null
        callback.apply(context, lastArgs)
      }
      const throttled = (...args) => {
        lastArgs = args
        if (requestId === null) {
          requestId = requestAnimationFrame(later(this))
        }
      }
      throttled.cancel = () => {
        cancelAnimationFrame(requestId)
        requestId = null
      }
      return throttled
    },

    debounce: (fn, wait) => {
      let timer
      return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => fn.apply(this, args), wait)
      }
    },

    waitForEvent: (element, eventName) => {
      return new Promise((resolve) => {
        const done = (event) => {
          if (event.target === element) {
            element.removeEventListener(eventName, done)
            resolve(event)
          }
        }
        element.addEventListener(eventName, done)
      })
    },

    fetchConfig: (type = 'json', method = 'POST') => {
      return {
        method: method,
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
      }
    },

    isUnloading: () => theme.utils._unloading === true,

    isBenignFetchError: (error) => error?.name === 'AbortError' || theme.utils.isUnloading(),

    reportFetchError: (label, error) => {
      if (theme.utils.isBenignFetchError(error)) return
      console.error(`[${label}]`, error)
    },

    _cartWrites: Promise.resolve(),

    queueCartWrite: (task) => {
      const run = theme.utils._cartWrites.then(
        () => task(),
        () => task()
      )
      theme.utils._cartWrites = run.then(
        () => undefined,
        () => undefined
      )
      return run
    },

    fetchWithRetry: async (resource, options = {}, { retries = 2, backoff = 300, label = 'fetch' } = {}) => {
      for (let attempt = 0; ; attempt++) {
        try {
          return await fetch(resource, options)
        }
        catch (error) {
          if (attempt >= retries || theme.utils.isBenignFetchError(error)) {
            error.themeLabel = label
            throw error
          }
          await new Promise((resolve) => setTimeout(resolve, backoff * Math.pow(3, attempt)))
        }
      }
    },

    postLink: (path, options) => {
      options = options || {}
      const method = options['method'] || 'post'
      const params = options['parameters'] || {}

      const form = document.createElement('form')
      form.setAttribute('method', method)
      form.setAttribute('action', path)

      for (const key in params) {
        const hiddenField = document.createElement('input')
        hiddenField.setAttribute('type', 'hidden')
        hiddenField.setAttribute('name', key)
        hiddenField.setAttribute('value', params[key])
        form.appendChild(hiddenField)
      }
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    },

    postLink2: (path, options) => {
      options = options || {}
      const method = options['method'] || 'post'
      const params = options['parameters'] || {}

      const form = document.createElement('form')
      form.setAttribute('method', method)
      form.setAttribute('action', path)

      for (const key in params) {
        if (typeof params[key] === 'string') {
          const hiddenField = document.createElement('input')
          hiddenField.setAttribute('type', 'hidden')
          hiddenField.setAttribute('name', key)
          hiddenField.setAttribute('value', params[key])
          form.appendChild(hiddenField)
        } else {
          for (const index in params[key]) {
            for (const key2 in params[key][index]) {
              const hiddenField = document.createElement('input')
              hiddenField.setAttribute('type', 'hidden')
              hiddenField.setAttribute('name', `${key}[${index}][${key2}]`)
              hiddenField.setAttribute('value', params[key][index][key2])
              form.appendChild(hiddenField)
            }
          }
        }
      }
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    },

    sectionId: (element) => {
      if (element.hasAttribute('data-section-id')) return element.getAttribute('data-section-id')

      element = element.classList.contains('shopify-section') ? element : element.closest('.shopify-section')
      return element.id.replace('shopify-section-', '')
    },

    imageLoaded: (imageOrArray) => {
      if (!imageOrArray) {
        return Promise.resolve()
      }
      imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray)
      return Promise.all(
        imageOrArray.map((image) => {
          return new Promise((resolve) => {
            if ((image.tagName === 'IMG' && image.complete) || !image.offsetParent) {
              resolve()
            } else {
              image.onload = () => resolve()
            }
          })
        })
      )
    },

    visibleMedia: (media) => {
      return Array.from(media).find((item) => {
        const style = window.getComputedStyle(item)
        return style.display !== 'none'
      })
    },

    setScrollbarWidth: () => {
      const scrollbarWidth = window.innerWidth - document.body.clientWidth
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth > 0 ? scrollbarWidth : 0}px`)
    },

    externalLinksNewTab: () => {
      if (theme.settings.externalLinksNewTab) {
        document.addEventListener('click', (evt) => {
          const link = evt.target.tagName === 'A' ? evt.target : evt.target.closest('a')
          if (link && link.tagName === 'A' && window.location.hostname !== new URL(link.href).hostname) {
            link.target = '_blank'
          }
        })
      }
    }
  }

  window.addEventListener('pagehide', () => (theme.utils._unloading = true))
  window.addEventListener('beforeunload', () => (theme.utils._unloading = true))
  window.addEventListener('pageshow', () => (theme.utils._unloading = false))

  theme.HTMLUpdateUtility = {
    /**
     * Used to swap an HTML node with a new node.
     * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
     *
     * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
     */
    viewTransition: (oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) => {
      preProcessCallbacks?.forEach((callback) => callback(newContent))

      const newNodeWrapper = document.createElement('div')
      theme.HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML)
      const newNode = newNodeWrapper.firstChild

      // dedupe IDs
      const uniqueKey = Date.now()
      oldNode.querySelectorAll('[id], [form]').forEach((element) => {
        element.id && (element.id = `${element.id}-${uniqueKey}`)
        element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`)
      })

      oldNode.parentNode.insertBefore(newNode, oldNode)
      oldNode.style.display = 'none'

      postProcessCallbacks?.forEach((callback) => callback(newNode))

      setTimeout(() => oldNode.remove(), 500)
    },

    // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    setInnerHTML: (element, html) => {
      element.innerHTML = html
      element.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script')
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        })
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML))
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag)
      })
    }
  }

  theme.Currency = {
    formatMoney: (cents, format = '') => {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '')
      }
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || window.themeVariables.settings.moneyFormat
      function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2)
        thousands = defaultTo(thousands, ',')
        decimal = defaultTo(decimal, '.')
        if (isNaN(number) || number == null) {
          return 0
        }
        number = (number / 100).toFixed(precision)
        let parts = number.split('.'),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : ''
        return dollarsAmount + centsAmount
      }
      let value = ''
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2)
          break
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0)
          break
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.')
          break
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',')
          break
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.')
          break
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',')
          break
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ')
          break
        case 'amount_no_decimals_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 0, "'")
          break
        default:
          value = formatWithDelimiters(cents, 2)
          break
      }
      if (formatString.indexOf('with_comma_separator') !== -1) {
        return formatString.replace(placeholderRegex, value)
      } else {
        return formatString.replace(placeholderRegex, value)
      }
    }
  }

  theme.pubsub = {
    PUB_SUB_EVENTS: {
      cartUpdate: 'cartUpdate',
      quantityUpdate: 'quantityUpdate',
      variantChange: 'variantChange',
      cartError: 'cartError',
      discountUpdate: 'discountUpdate',
      facetUpdate: 'facetUpdate',
      quantityRules: 'quantityRules',
      quantityBoundries: 'quantityBoundries',
      optionValueSelectionChange: 'optionValueSelectionChange'
    },

    subscribers: {},

    subscribe: (eventName, callback) => {
      if (theme.pubsub.subscribers[eventName] === undefined) {
        theme.pubsub.subscribers[eventName] = []
      }

      theme.pubsub.subscribers[eventName] = [...theme.pubsub.subscribers[eventName], callback]

      return function unsubscribe() {
        theme.pubsub.subscribers[eventName] = theme.pubsub.subscribers[eventName].filter((cb) => {
          return cb !== callback
        })
      }
    },

    publish: (eventName, data) => {
      if (theme.pubsub.subscribers[eventName]) {
        theme.pubsub.subscribers[eventName].forEach((callback) => {
          callback(data)
        })
      }
    }
  }

  theme.scrollShadow = {
    Updater: (function () {
      class Updater {
        constructor(targetElement) {
          this.cb = () => this.update(targetElement)
          this.rO = new ResizeObserver(this.cb)
          this.mO = new MutationObserver(() => this.on(this.el))
        }
        on(element) {
          if (this.el) {
            this.el.removeEventListener('scroll', this.cb)
            this.rO.disconnect()
            this.mO.disconnect()
          }
          if (!element) return
          if (element.nodeName === 'TABLE' && !/scroll|auto/.test(getComputedStyle(element).getPropertyValue('overflow'))) {
            this.rO.observe(element)
            element = element.tBodies[0]
          }
          element.addEventListener('scroll', this.cb)
          ;[element, ...element.children].forEach((el) => this.rO.observe(el))
          this.mO.observe(element, { childList: true })
          this.el = element
        }
        update(targetElement) {
          const scrollTop = this.el.scrollTop
          const scrollBottom = this.el.scrollHeight - this.el.offsetHeight - this.el.scrollTop
          const scrollLeft = this.el.scrollLeft
          const scrollRight = this.el.scrollWidth - this.el.offsetWidth - this.el.scrollLeft * (theme.config.rtl ? -1 : 1)
          let cssText = `--t: ${Math.floor(scrollTop) > 0 ? 1 : 0}; --b: ${Math.floor(scrollBottom) > 0 ? 1 : 0}; --l: ${Math.floor(scrollLeft) > 0 ? 1 : 0}; --r: ${Math.floor(scrollRight) > 0 ? 1 : 0};`
          if (this.el.nodeName === 'TBODY') {
            const clientRect = this.el.getBoundingClientRect()
            const rootClientRect = this.el.parentElement.getBoundingClientRect()
            cssText += `top: ${clientRect.top - rootClientRect.top}px; bottom: ${rootClientRect.bottom - clientRect.bottom}px; left: ${clientRect.left - rootClientRect.left}px; right: ${rootClientRect.right - clientRect.right}px;`
          }
          requestAnimationFrame(() => {
            targetElement.style.cssText = cssText
          })
        }
      }

      return Updater
    })()
  }

  theme.cookiesEnabled = function () {
    let cookieEnabled = navigator.cookieEnabled

    if (!cookieEnabled) {
      document.cookie = 'testcookie'
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1
    }
    return cookieEnabled
  }

  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false
    }

    const testKey = 'test'
    let storage
    if (type === 'session') {
      storage = window.sessionStorage
    }
    if (type === 'local') {
      storage = window.localStorage
    }

    try {
      storage.setItem(testKey, '1')
      storage.removeItem(testKey)
      return true
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
      return false
    }
  }

  theme.getElementWidth = function (element, value) {
    const style = window.getComputedStyle(element)

    const text = document.createElement('span')
    text.style.fontFamily = style.fontFamily
    text.style.fontSize = style.fontSize
    text.style.fontWeight = style.fontWeight
    text.style.visibility = 'hidden'
    text.style.position = 'absolute'
    text.innerHTML = value

    document.body.appendChild(text)
    const width = text.getBoundingClientRect().width
    text.remove()

    return width
  }

  theme.HoverButton = (function () {
    class HoverButton {
      constructor(container) {
        this.container = container
      }

      get btnFill() {
        return this.container.querySelector('[data-fill]')
      }

      load() {
        if (theme.config.isTouch || document.body.getAttribute('data-button-hover') === 'none') return

        this.container.addEventListener('mouseenter', this.onEnterHandler.bind(this))
        this.container.addEventListener('mouseleave', this.onLeaveHandler.bind(this))
      }

      onEnterHandler() {
        if (this.btnFill) {
          Motion.animate(this.btnFill, { y: ['76%', '0%'] }, { duration: 0.6 })
        }
      }

      onLeaveHandler() {
        if (this.btnFill) {
          Motion.animate(this.btnFill, { y: '-76%' }, { duration: 0.6 })
        }
      }

      unload() {
        // todo
      }
    }

    return HoverButton
  })()

  theme.MagnetButton = (function () {
    const config = {
      magnet: 10
    }

    class MagnetButton {
      constructor(container) {
        this.container = container
        this.magnet = container.hasAttribute('data-magnet') ? parseInt(container.getAttribute('data-magnet')) : config.magnet
      }

      get btnText() {
        return this.container.querySelector('[data-text]')
      }

      get bounding() {
        return this.container.getBoundingClientRect()
      }

      load() {
        if (theme.config.isTouch || document.body.getAttribute('data-button-hover') === 'none') return

        this.container.addEventListener('mousemove', this.onMoveHandler.bind(this))
        this.container.addEventListener('mouseleave', this.onLeaveHandler.bind(this))
      }

      onMoveHandler(event) {
        if (theme.config.motionReduced) return
        if (this.magnet === 0) return

        if (this.btnText) {
          Motion.animate(
            this.btnText,
            {
              x: ((event.clientX - this.bounding.left) / this.container.offsetWidth - 0.5) * this.magnet,
              y: ((event.clientY - this.bounding.top) / this.container.offsetHeight - 0.5) * this.magnet
            },
            { duration: 1.5, easing: Motion.spring() }
          )
        } else {
          Motion.animate(
            this.container,
            {
              x: ((event.clientX - this.bounding.left) / this.container.offsetWidth - 0.5) * this.magnet,
              y: ((event.clientY - this.bounding.top) / this.container.offsetHeight - 0.5) * this.magnet
            },
            { duration: 1.5, easing: Motion.spring() }
          )
        }
      }

      onLeaveHandler() {
        if (theme.config.motionReduced) return
        if (this.magnet === 0) return

        if (this.btnText) {
          Motion.animate(this.btnText, { x: 0, y: 0 }, { duration: 1.5, easing: Motion.spring() })
        } else {
          Motion.animate(this.container, { x: 0, y: 0 }, { duration: 1.5, easing: Motion.spring() })
        }
      }

      unload() {
        // todo
      }
    }

    return MagnetButton
  })()

  theme.RevealButton = (function () {
    const config = {
      magnet: 25
    }

    class RevealButton {
      constructor(container) {
        this.container = container
        this.magnet = container.hasAttribute('data-magnet') ? parseInt(container.getAttribute('data-magnet')) : config.magnet
      }

      get btnText() {
        return this.container.querySelector('[data-text]')
      }

      get btnReveal() {
        return this.container.querySelector('[data-reveal]')
      }

      get bounding() {
        return this.container.getBoundingClientRect()
      }

      load() {
        if (theme.config.isTouch) return

        this.container.addEventListener('mousemove', this.onMoveHandler.bind(this))
        this.container.addEventListener('mouseleave', this.onLeaveHandler.bind(this))
      }

      onMoveHandler(event) {
        if (this.btnReveal) {
          Motion.animate(
            this.btnReveal,
            {
              opacity: 1,
              x: ((event.clientX - this.bounding.left) / this.container.offsetWidth - 0.5) * this.magnet,
              y: ((event.clientY - this.bounding.top) / this.container.offsetHeight - 0.5) * this.magnet
            },
            { duration: 0.2, easing: 'steps(2, start)' }
          )
        } else if (this.btnText) {
          Motion.animate(
            this.btnText,
            {
              x: ((event.clientX - this.bounding.left) / this.container.offsetWidth - 0.5) * this.magnet,
              y: ((event.clientY - this.bounding.top) / this.container.offsetHeight - 0.5) * this.magnet
            },
            { duration: 1.5, easing: Motion.spring() }
          )
        } else {
          Motion.animate(
            this.container,
            {
              x: ((event.clientX - this.bounding.left) / this.container.offsetWidth - 0.5) * this.magnet,
              y: ((event.clientY - this.bounding.top) / this.container.offsetHeight - 0.5) * this.magnet
            },
            { duration: 1.5, easing: Motion.spring() }
          )
        }
      }

      onLeaveHandler() {
        if (this.btnReveal) {
          Motion.animate(this.btnReveal, { x: 0, y: 0, opacity: 0 }, { duration: 0.2, easing: [0.61, 1, 0.88, 1] })
        } else if (this.btnText) {
          Motion.animate(this.btnText, { x: 0, y: 0 }, { duration: 1.5, easing: Motion.spring() })
        } else {
          Motion.animate(this.container, { x: 0, y: 0 }, { duration: 1.5, easing: Motion.spring() })
        }
      }

      unload() {
        // todo
      }
    }

    return RevealButton
  })()

  theme.Animation = (function () {
    class Animation {
      constructor(container) {
        this.container = container
      }

      get immediate() {
        return this.container.hasAttribute('data-immediate')
      }

      get media() {
        return Array.from(this.container.querySelectorAll('img, iframe, svg, g-map'))
      }

      get type() {
        return this.container.hasAttribute('data-animate') ? this.container.getAttribute('data-animate') : 'fade-up'
      }

      get delay() {
        return this.container.hasAttribute('data-animate-delay') ? parseInt(this.container.getAttribute('data-animate-delay')) / 1000 : 0
      }

      get paused() {
        return this.container.hasAttribute('paused')
      }

      beforeLoad() {
        if (this.type === 'none' || this.paused) return

        switch (this.type) {
          case 'fade-in':
            Motion.animate(this.container, { opacity: 0 }, { duration: 0 })
            break

          case 'fade-up':
            Motion.animate(this.container, { transform: 'translateY(min(2rem, 90%))', opacity: 0 }, { duration: 0 })
            break

          case 'fade-up-large':
            Motion.animate(this.container, { transform: 'translateY(90%)', opacity: 0 }, { duration: 0 })
            break

          case 'zoom-out':
            Motion.animate(this.container, { transform: 'scale(1.3)' }, { duration: 0 })
            break
        }
      }

      async load() {
        if (this.type === 'none' || this.paused) return

        switch (this.type) {
          case 'fade-in':
            await Motion.animate(this.container, { opacity: 1 }, { duration: 1.5, delay: this.delay, easing: [0.16, 1, 0.3, 1] }).finished
            break

          case 'fade-up':
            await Motion.animate(
              this.container,
              { transform: 'translateY(0)', opacity: 1 },
              { duration: 1.5, delay: this.delay, easing: [0.16, 1, 0.3, 1] }
            ).finished
            break

          case 'fade-up-large':
            await Motion.animate(
              this.container,
              { transform: 'translateY(0)', opacity: 1 },
              { duration: 1, delay: this.delay, easing: [0.16, 1, 0.3, 1] }
            ).finished
            break

          case 'zoom-out':
            await Motion.animate(this.container, { transform: 'scale(1)' }, { duration: 1.3, delay: this.delay, easing: [0.16, 1, 0.3, 1] }).finished
            break
        }

        this.container.classList.add('animated')
      }

      async reset(duration) {
        if (this.type === 'none') return

        switch (this.type) {
          case 'fade-in':
            await Motion.animate(
              this.container,
              { opacity: 0 },
              { duration: duration ? duration : 1.5, delay: this.delay, easing: duration ? 'none' : [0.16, 1, 0.3, 1] }
            ).finished
            break

          case 'fade-up':
            await Motion.animate(
              this.container,
              { transform: 'translateY(max(-2rem, -90%))', opacity: 0 },
              { duration: duration ? duration : 1.5, delay: this.delay, easing: duration ? 'none' : [0.16, 1, 0.3, 1] }
            ).finished
            break

          case 'fade-up-large':
            await Motion.animate(
              this.container,
              { transform: 'translateY(-90%)', opacity: 0 },
              { duration: duration ? duration : 1, delay: this.delay, easing: duration ? 'none' : [0.16, 1, 0.3, 1] }
            ).finished
            break

          case 'zoom-out':
            await Motion.animate(
              this.container,
              { transform: 'scale(0)' },
              { duration: duration ? duration : 1.3, delay: this.delay, easing: duration ? 'none' : [0.16, 1, 0.3, 1] }
            ).finished
            break
        }

        this.container.classList.remove('animated')
      }

      reload() {
        if (this.type === 'none') return

        this.container.removeAttribute('paused')
        this.beforeLoad()
        this.load()
      }

      unload() {
        // todo
      }
    }

    return Animation
  })()

  theme.Carousel = (function () {
    class Carousel {
      constructor(container, options, navigation) {
        this.container = container
        this.options = options
        this.prevButton = navigation.previous
        this.nextButton = navigation.next
      }

      load() {
        this.slider = new Flickity(this.container, this.options)

        this.prevButton.addEventListener('click', this.onPrevButtonClick.bind(this))
        this.nextButton.addEventListener('click', this.onNextButtonClick.bind(this))

        this.slider.on('dragStart', this.onDragStartHandler.bind(this))
        this.slider.on('select', this.onSelectHandler.bind(this))
      }

      onDragStartHandler() {
        this.prevRemoveTransform()
        this.nextRemoveTransform()
      }

      onSelectHandler() {
        if (!this.slider.slides[this.slider.selectedIndex - 1]) {
          this.prevButton.disabled = true
          this.nextButton.disabled = false
        } else if (!this.slider.slides[this.slider.selectedIndex + 1]) {
          this.prevButton.disabled = false
          this.nextButton.disabled = true
        } else {
          this.prevButton.disabled = false
          this.nextButton.disabled = false
        }
      }

      onPrevButtonClick(event) {
        event.preventDefault()

        this.slider.previous()
        this.nextRemoveTransform()
      }

      onNextButtonClick(event) {
        event.preventDefault()

        this.slider.next()
        this.prevRemoveTransform()
      }

      prevRemoveTransform() {
        this.prevButton.style.transform = null
        this.prevButton.querySelector('[data-fill]').style.transform = null
      }

      nextRemoveTransform() {
        this.nextButton.style.transform = null
        this.nextButton.querySelector('[data-fill]').style.transform = null
      }

      unload() {
        // todo
      }
    }

    return Carousel
  })()

  // Delay JavaScript until user interaction
  theme.initWhenVisible = (function () {
    class ScriptLoader {
      constructor(callback, delay = 5000) {
        this.callback = callback
        this.triggered = false
        this.timeoutId = null

        this.interactionEvents = ['click', 'mousemove', 'keydown', 'touchstart', 'touchmove', 'wheel']
        this.handleInteraction = this.handleInteraction.bind(this)

        this.interactionEvents.forEach((eventType) => {
          window.addEventListener(eventType, this.handleInteraction, { passive: true })
        })

        this.timeoutId = setTimeout(() => {
          if (!this.triggered) {
            this.handleInteraction({ type: 'timeout' })
          }
        }, delay)
      }

      handleInteraction(event) {
        if (this.triggered) return

        this.triggered = true
        this.callback(event)
        this.cleanup()
      }

      cleanup() {
        this.interactionEvents.forEach((eventType) => {
          window.removeEventListener(eventType, this.handleInteraction, { passive: true })
        })

        clearTimeout(this.timeoutId)
        this.timeoutId = null
        this.callback = null
      }
    }

    return ScriptLoader
  })()

  // Improve initial load time by skipping the rendering of offscreen content
  new theme.initWhenVisible(() => {
    document.body.removeAttribute('data-page-rendering')
  })

  // Improve iOS Safari resizing
  theme.windowWidth = window.innerWidth
  window.addEventListener('resize', () => {
    const { innerWidth } = window
    if (innerWidth !== theme.windowWidth) {
      theme.windowWidth = innerWidth
      document.dispatchEvent(new CustomEvent('window:resize'))
    }
  })

  theme.DOMready(theme.headerGroup.init)
  theme.DOMready(theme.utils.setScrollbarWidth)
  theme.DOMready(theme.utils.externalLinksNewTab)
  document.addEventListener('window:resize', theme.utils.throttle(theme.utils.setScrollbarWidth))

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  theme.config.hasSessionStorage = theme.isStorageSupported('session')
  theme.config.hasLocalStorage = theme.isStorageSupported('local')

  // Trigger events when going between breakpoints
  const mql = window.matchMedia(theme.config.mediaQuerySmall)
  theme.config.mqlSmall = mql.matches
  mql.onchange = (mql) => {
    if (mql.matches) {
      theme.config.mqlSmall = true
      document.dispatchEvent(new CustomEvent('matchSmall'))
    } else {
      theme.config.mqlSmall = false
      document.dispatchEvent(new CustomEvent('unmatchSmall'))
    }
  }

  // Page has loaded and theme assets are ready
  window.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('loaded')
    document.dispatchEvent(new CustomEvent('page:loaded'))
  })
  window.addEventListener('pageshow', (event) => {
    // Removes unload class when returning to page via history
    if (event.persisted) {
      document.body.classList.remove('unloading')
    }
  })
  window.addEventListener('beforeunload', () => {
    document.body.classList.add('unloading')
  })
})()

// Prevent vertical scroll while using flickity sliders
new theme.initWhenVisible(() => {
  var e = !1
  var t

  document.body.addEventListener(
    'touchstart',
    function (i) {
      if (!i.target.closest('.flickity-slider')) {
        return (e = !1)
        void 0
      }
      e = !0
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      }
    },
    theme.supportsPassive ? { passive: true } : false
  )

  document.body.addEventListener(
    'touchmove',
    function (i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y
        }
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
      }
    },
    theme.supportsPassive ? { passive: false } : false
  )
})

